import React from 'react'

import {
  Dialog,
  DialogAction,
  DialogCancel,
  DialogContent,
  DialogOverlay,
} from '@wartek-id/dialog'
import { Text } from '@wartek-id/text'

import type { ConfirmNavigateAwayDialogProps } from 'types/microlearning'

import QuestionMarkIcon from 'assets/icons/questionmark-fill.svg'

const ConfirmNavigateAwayDialog = ({
  isOpen,
  onClose,
  onConfirmed,
  title,
  description,
  children,
  icon = null,
  confirmText = 'Ya',
  cancelText = 'Tidak',
}: ConfirmNavigateAwayDialogProps) => {
  return (
    <Dialog isOpen={isOpen} onClose={onClose}>
      <DialogOverlay />
      <DialogContent>
        <section className="p-3">
          <div className="w-full mb-6">
            <div className="flex items-center justify-center mx-auto w-14 h-14 rounded-full">
              {icon === null && (
                <QuestionMarkIcon
                  width={56}
                  height={56}
                  className="fill-current text-warning"
                />
              )}
              {icon}
            </div>
          </div>
          <div className="mb-2 text-center">
            <Text as="span" variant="heading-sm">
              {title}
            </Text>
          </div>
          <div className="mb-6 text-center">
            <Text color="subdued">
              {typeof description === 'string' ? description : children}
            </Text>
          </div>
          <DialogCancel
            onClick={onClose}
            className="block w-full h-[44px] mb-2 leading-[2.75] bg-interactive-default font-bold text-center text-white rounded-lg focus:ring-1 disabled:bg-surface-disabled disabled:text-icon-disabled"
          >
            {cancelText}
          </DialogCancel>
          <DialogAction
            onClick={onConfirmed}
            className="block w-full h-[44px] leading-[2.75] border border-default font-bold focus:ring-1 rounded-lg"
          >
            {confirmText}
          </DialogAction>
        </section>
      </DialogContent>
    </Dialog>
  )
}

export default ConfirmNavigateAwayDialog
